import React from 'react';
import { NOTIFICATION_HANDLER } from '@Constants/types';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import { useSelector } from 'react-redux';
import MetaDataList from '../MetaDataList';
import store from '@Store';
import MetaDataValues from './components/MetaDataValues';
import Accordion from '@Components/Accordion';
import { MIX_PANEL } from '@Constants/types';
import mixpanelEvents from '@Mixpanel';

const MetaDataItem = ({ name, values, subgroups, labelIndex }) => {
    const { navigating, navigatingTo } = useSelector(state => state.search);

    const hasValues = () => {
        try {
            return values.some(x => x.value !== '');
        } catch (err) {
            addLog(LOG_TYPE.ERROR, 'MetaDataItem.hasValues', err);
            store.dispatch({
                type: NOTIFICATION_HANDLER.ERROR,
                payload: err
            });

            return false;
        }
    };

    const mixPanelEvent = isOpen => {
        let numOfExtractions = 0;
        let numOfExtractionChars = 0;
        if (values && values.length > 0) {
            numOfExtractions = values.length;
            if (numOfExtractions > 0) {
                values.forEach(extraction => {
                    numOfExtractionChars += extraction.value.length;
                });
            }
        }

        const mixpanel = {
            displayId: name,
            labelPosition: labelIndex,
            numberOfExtractions: numOfExtractions,
            numberOfExtractionChars: numOfExtractionChars
        };
        store.dispatch({
            type: MIX_PANEL.MIXPANEL_DATA_LABELS,
            payload: mixpanel
        });

        if (isOpen) {
            mixpanelEvents.labelcollapsed();
        } else {
            mixpanelEvents.labelexpanded();
        }
    };

    return (
        hasValues() && (
            <li data-testid={`label_${labelIndex}`} style={{ width: '100%' }}>
                <Accordion
                    title={name}
                    isLoading={navigating && navigatingTo.name === name}
                    mixPanelEvent={mixPanelEvent}
                    data-testid="label-title"
                >
                    <MetaDataValues
                        name={name}
                        metadataValues={values}
                        labelIndex={labelIndex}
                        data-testid="label-values-container"
                    />
                    {subgroups &&
                        subgroups.map(({ name: listName, items: metalist }, i) => (
                            <MetaDataList
                                isSubGroup
                                listName={listName}
                                key={`${name}-${i}`}
                                metalist={metalist}
                            />
                        ))}
                </Accordion>
            </li>
        )
    );
};

export default MetaDataItem;
